module.exports = __webpack_public_path__ + "img/screener.a40689b7.svg";